
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FormItemConf, FileRules } from './index';

import PickerInput from '../PickerInput.vue';
import Uploader from '../Uploader.vue';
import SyEditor from '../SyEditor.vue';
import TextInput from '../TextInput.vue';
import FormSearchInput from './FormSearchInput.vue';
@Component({
  components: {
    PickerInput,
    Uploader,
    SyEditor,
    TextInput,
    FormSearchInput,
  },
})
export default class FormItem extends Vue {
  @Prop({ required: true }) itemConf!: FormItemConf;

  get title() {
    return this.itemConf.require
      ? `${this.itemConf.title} *`
      : this.itemConf.title;
  }

  get fileLength() {
    if (this.$refs.uploader) {
      return (this.$refs.uploader as Uploader).displayImages.length;
    } else {
      return null;
    }
  }
  // 处理文件类型默认参数
  get fileRules() {
    const temp: FileRules = this.itemConf.fileRules
      ? this.itemConf.fileRules
      : {};
    return {
      minLength: temp.minLength ? temp.minLength : 1,
      maxLength: temp.minLength
        ? temp.maxLength
        : this.itemConf.type === 'image'
        ? 9
        : 1,
      fileMaxSize: temp.fileMaxSize
        ? temp.fileMaxSize
        : this.itemConf.type === 'image'
        ? 10
        : 100,
      fileMinSize: temp.fileMinSize !== undefined ? temp.fileMinSize : 0.01,
      mustInApp: temp.mustInApp !== undefined ? temp.mustInApp : true,
      needCompress: temp.needCompress !== undefined ? temp.needCompress : true,
      cropConfig: temp.cropConfig !== undefined ? temp.cropConfig : null,
      mustSelectFile:
        temp.mustSelectFile !== undefined ? temp.mustSelectFile : true,
    };
  }
  // mounted() {
  //   setTimeout(() => {
  //     (this.$refs.syEditor as SyEditor).clear();
  //   }, 5000);
  // }
  //
  selectData(e: any, index: number) {
    this.itemConf.value = e;
  }

  // 上传图片方法
  uploadFile() {
    return (this.$refs.uploader as Uploader).uploadToOss();
  }

  // 获取文本信息
  getContent(pureText: boolean) {
    if (pureText) {
      return (this.$refs.syEditor as SyEditor).getPlainText();
    } else {
      return (this.$refs.syEditor as SyEditor).content;
    }
  }
}
